export default __webpack_public_path__ + "static/20-sitzer-4-d4c3be119784b5003fe9acfa96cd8c43.jpg";